(function(window, mL, mL_errors, mL_events, mL_config) {
    "use strict";

    var key = 'criteo';

    if (mL_config.do_not_track || !mL_config.tags || !mL_config.tags.criteo) return;

    window.criteo_q = window.criteo_q || [];

    var obj = {};

    var email = false;

    function get_properties(ev_obj) {
        var arr = [
            { event: "setAccount", account: 54250 },
            { event: "setSiteType", type: mL.device_type }
        ];

        if (email) {
            arr.push({ event: "setEmail", email: email });
        } else {
            if (mL.md5_email) {
                email = mL.md5_email();
            }
            if (email) {
                arr.push({ event: "setEmail", email: email });
            } else {
                arr.push({ event: "setEmail", email: "" });
            }
        }

        if (ev_obj) arr.push(ev_obj);

        return arr;
    }

    function send_event(event_obj) {
        var arr = get_properties(event_obj);
        window.criteo_q.push(arr);
    }

    obj.home = function() {
        var criteo_obj = { event: "viewHome" };

        send_event(criteo_obj);

        if (mL_config.DEBUG) console.log(key + ' - criteo_obj', criteo_obj);
    };

    mL_events.subscribe('page.item', function(msg, data) {
        if (!data.item || !data.item.sku) return;

        var criteo_obj = { event: "viewItem", item: data.item.sku };

        send_event(criteo_obj);

        if (mL_config.DEBUG) console.log(key + ' - ' + msg,  { criteo_obj: criteo_obj });
    });

    mL_events.subscribe('page.category', function(msg, data) {
        if (!data.category || !data.category.item_list || data.category.item_list.length < 1) return;

        var criteo_obj = { event: "viewList", item: data.category.item_list };

        send_event(criteo_obj);

        if (mL_config.DEBUG) console.log(key + ' - ' + msg,  { criteo_obj: criteo_obj });
    });

    mL_events.subscribe('page.cart', function(msg, data) {
        if (!data.cart || !data.cart.items || data.cart.items.length < 1) return;

        var items = data.cart.items;

        var _items = [],
            i = 0,
            l = items.length;

        for (i; i < l; i += 1) {
            _items.push({ id: items[i].itemid, price: items[i].rate, quantity: items[i].quantity });
        }

        var criteo_obj = { event: "viewBasket", item: _items };

        send_event(criteo_obj);

        if (mL_config.DEBUG) console.log(key + ' - ' + msg, { criteo_obj: criteo_obj });
    });

    mL_events.subscribe('order.confirmation', function(msg, data) {
        var _order = data.order;
        var _items = [];

        _order.items.forEach(function(item) {
            var criteo_item = {
                id: item.sku,
                price: item.rate,
                quantity: item.quantity
            };
            _items.push(criteo_item);
        });

        var criteo_obj = { event: "trackTransaction", id: _order.order_id, item: _items };

        if (!data.is_dev) send_event(criteo_obj);

        if (mL_config.DEBUG) console.log(key + ' - ' + msg + ' - data', criteo_obj);
    });
 

    obj.init = function() {
        if (!mL.criteo || mL.criteo.is_init || !mL.add_tracker || !window.criteo_q) return false;

        mL.add_tracker('https://static.criteo.net/js/ld/ld.js', 'criteo');

        mL.criteo.is_init = true;

        if (document.getElementById('mlahart_home')) {
            obj.home();
        }

        if (mL_config.DEBUG) console.log(key + ' - plugin loaded');
    };


    mL.criteo = obj;

}(window, window.mL, window.mL_errors, window.mL_events, window.mL_config));